












# import settings from '@/settings'
import company_form from '@/components/company_form'
import t from '@/utils/tools'

export default {
    name: 'company_company'

    components: {company_form}

    props: {
        uid: {
            type: String
            default: ''
        }
    }

    methods:
        has_access_right: t.has_access_right

        change_distribution: ()->
            # console.log "EMIT COMPANY COMPANY"
            @$emit('change-distribution')

    # mounted: ()->
    #     console.log "COMPANY COMPANY MOUNTED", @uid
}
